<hk-top-bar *ngIf="!embedded" class="basis-auto"></hk-top-bar>
<div class="relative flex flex-1 overflow-hidden">
  <router-outlet></router-outlet>
</div>
